"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployProgressMessage = exports.Constants = void 0;
const localizeUtils_1 = require("../../../../../common/localizeUtils");
class Constants {
    static APP_CATALOG_REFRESH_TIME = 20000;
    static APP_CATALOG_MAX_TIMES = 6;
    static APP_CATALOG_ACTIVE_TIME = 180000;
    static DeployDriverName = "spfx/deploy";
    static TelemetryComponentName = "fx-resource-spfx";
    static TelemetryDeployEventName = "deploy";
    static DeployProgressTitle = () => (0, localizeUtils_1.getLocalizedString)("plugins.spfx.deploy.title");
    static DevProgramLink = "https://developer.microsoft.com/en-us/microsoft-365/dev-program";
}
exports.Constants = Constants;
class DeployProgressMessage {
    static SkipCreateSPAppCatalog = () => (0, localizeUtils_1.getLocalizedString)("driver.spfx.deploy.skipCreateAppCatalog");
    static CreateSPAppCatalog = () => (0, localizeUtils_1.getLocalizedString)("driver.spfx.deploy.createAppCatalog");
    static Upload = () => (0, localizeUtils_1.getLocalizedString)("driver.spfx.deploy.uploadPackage");
    static Deploy = () => (0, localizeUtils_1.getLocalizedString)("driver.spfx.deploy.deployPackage");
}
exports.DeployProgressMessage = DeployProgressMessage;
//# sourceMappingURL=constants.js.map